import { render } from "./answerVisible.vue?vue&type=template&id=385b6dc2"
import script from "./answerVisible.vue?vue&type=script&lang=js"
export * from "./answerVisible.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__